// 정적 examData 시스템
// GUI에서 파일에 직접 데이터를 추가하고 프론트엔드에서 읽는 단순한 구조

import { sessionsManifest } from './examSessionsManifest';

// 기본 examData 객체 (GUI가 데이터를 추가할 위치)
export const examData = {
  'confectionery-technician': {
    title: '제과기능사',
    description: '제과기능사 필기 기출문제',
    totalQuestions: 60,
    timeLimit: 60,
    passingScore: 60,
    popular: false,
    subjects: ['제조이론', '재료과학', '영양학', '식품위생'],
    years: {},
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 40.0,
      popularSessions: []
    }
  },
  'electrical-engineer': {
    title: '전기기사',
    description: '전기 설비의 설계, 시공, 운영 및 유지관리에 관한 업무',
    totalQuestions: 100,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['전기이론', '전력공학', '전기기기', '회로이론', '전기설비'],
    years: {
      2024: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 23.5
      },
      2023: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 23.5
      },
      2022: {
        sessions: { 1: { available: true }, 2: { available: true } },
        difficulty: 'medium',
        passRate: 23.5
      }
    },
    statistics: {
      totalExaminees: 45000,
      averagePassRate: 23.5,
      popularSessions: ['2024년 1회', '2024년 2회', '2024년 3회', '2023년 3회', '2023년 2회', '2023년 1회', '2022년 2회']
    }
  },
  'electrical-industrial-engineer': {
    title: '전기산업기사',
    description: '전기 산업 분야의 기술 업무 및 전기설비 운영관리',
    totalQuestions: 100,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['전기이론', '전기기기', '전기설비', '자동제어'],
    years: {
      2024: {
        sessions: { 1: { available: true, }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 35.2,
      },
      2023: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0,
      },
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 28.0
      }
    },
    statistics: {
      totalExaminees: 35000,
      averagePassRate: 35.2,
      popularSessions: ['2024년 3회', '2023년 2회', '2022년 1회']
    }
  },
  'electrical-technician': {
    title: '전기기능사',
    description: '전기설비의 설치, 점검, 수리 등 기능업무',
    totalQuestions: 60,
    timeLimit: 120,
    passingScore: 60,
    popular: true,
    subjects: ['전기이론', '전기기기', '전기설비', '회로이론'],
    years: {
      2020: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'easy',
        passRate: 45.3
      },
      2019: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2016: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 28000,
      averagePassRate: 44.5,
      popularSessions: ['2020년 2회', '2020년 1회', '2020년 3회']
    }
  },
  'fire-engineer-mechanic': {
    title: '소방설비기사(기계분야)',
    description: '소방설비기사(기계분야) 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['소방원론', '소방유체역학', '소방관계법규', '소방기계시설의 구조 및 원리'],
    years: {
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2021: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2020: {
        sessions: { 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2022년 1회', '2022년 2회', '2021년 4회']
    }
  },
  'industrial-safety-engineer': {
    title: '산업안전기사',
    description: '산업 현장의 안전관리, 위험성 평가, 안전교육 등에 관한 업무',
    totalQuestions: 120,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['산업안전보건법령', '안전관리론', '산업위생관리론', '인간공학 및 시스템 안전공학', '기계위험방지기술'],
    years: {
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 32.5
      },
      2021: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 30.0
      },
      2020: {
        sessions: { 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 40000,
      averagePassRate: 29.2,
      popularSessions: ['2022년 1회', '2021년 3회', '2021년 1회']
    }
  },
  'information-processing-engineer': {
    title: '정보처리기사',
    description: '소프트웨어 개발, 데이터베이스 구축, 네트워크 관리 등 IT 전반',
    totalQuestions: 100,
    timeLimit: 150,
    passingScore: 60,
    popular: true,
    subjects: ['소프트웨어 설계', '소프트웨어 개발', '데이터베이스 구축', '프로그래밍 언어 활용', '정보시스템 구축관리'],
    years: {
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 34.5
      },
      2021: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 32.0
      },
      2020: {
        sessions: { 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 85000,
      averagePassRate: 33.3,
      popularSessions: ['2022년 1회', '2021년 3회', '2021년 1회']
    }
  },
  'electrical-construction-engineer': {
    title: '전기공사기사',
    description: '전기공사의 설계, 시공, 검사 및 유지관리에 관한 업무',
    totalQuestions: 100,
    timeLimit: 150,
    passingScore: 60,
    popular: false,
    subjects: ['전기이론', '전기기기', '전력공학', '전기설비', '전기법규'],
    years: {
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 22.0
      },
      2021: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 22.0
      }
    },
    statistics: {
      totalExaminees: 18000,
      averagePassRate: 22.0,
      popularSessions: ['2022년 2회', '2021년 2회', '2021년 4회']
    }
  },
  'architectural-engineer': {
    title: '건축기사',
    description: '건축기사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2024: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2024년 2회']
    }
  },
  'forklift-operator-technician': {
    title: '지게차운전기능사',
    description: '지게차운전기능사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2011: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2010: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2011년 5회']
    }
  },
  'computer-applications-level2': {
    title: '컴퓨터활용능력2급',
    description: '컴퓨터활용능력2급 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2024: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2023: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2024년 4회']
    }
  },
  'computer-applications-level1': {
    title: '컴퓨터활용능력1급',
    description: '컴퓨터활용능력1급 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2024: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2023: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2024년 4회']
    }
  },
  'hvac-refrigeration-industrial-engineer': {
    title: '공조냉동기계산업기사',
    description: '공조냉동기계산업기사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['공기조화', '냉동공학', '배관일반', '전기제어공학'],
    years: {
      2020: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2019: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2018: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2020년 3회', '2019년 1회']
    }
  },
  'hazardous-materials-industrial-engineer': {
    title: '위험물산업기사',
    description: '위험물산업기사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2020: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2019: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2018: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2020년 2회']
    }
  },
  'fire-protection-engineer-electrical': {
    title: '소방설비기사(전기분야)',
    description: '소방설비기사(전기분야) 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2022: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2021: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2020: {
        sessions: { 2: { available: true }, 3: { available: true }, 4: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2021년 4회']
    }
  },
  'korean-cooking-technician': {
    title: '한식조리기능사',
    description: '한식조리기능사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2016: {
        sessions: { 1: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2015: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2014: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2013: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2012: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2016년 1회']
    }
  },
  'excavator-operator': {
    title: '굴착기운전기능사',
    description: '굴착기운전기능사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2013: {
        sessions: { 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2011: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2010: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2009: {
        sessions: { 1: { available: true }, 2: { available: true }, 4: { available: true }, 5: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2013년 5회']
    }
  },
  'forest-technician': {
    title: '산림기능사',
    description: '산림기능사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2016: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2015: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2014: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2013: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2012: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2011: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2016년 2회']
    }
  },
  'industrial-hygiene-engineer': {
    title: '산업위생관리기사',
    description: '산업위생관리기사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2022: {
        sessions: { 1: { available: true }, 2: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2021: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2020: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2019: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2018: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2022년 2회']
    }
  },
  'industrial-safety-industrial-engineer': {
    title: '산업안전산업기사',
    description: '산업안전산업기사 필기시험',
    totalQuestions: 80,
    timeLimit: 180,
    passingScore: 60,
    popular: true,
    subjects: ['기본과목'],
    years: {
      2020: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2019: {
        sessions: { 1: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2018: {
        sessions: { 1: { available: true }, 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2017: {
        sessions: { 1: { available: true }, 2: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      },
      2016: {
        sessions: { 2: { available: true }, 3: { available: true } },
        difficulty: 'medium',
        passRate: 25.0
      }
    },
    statistics: {
      totalExaminees: 30000,
      averagePassRate: 25.0,
      popularSessions: ['2020년 3회']
    }
  },












};

// 디스크에 존재하는 session 파일을 자동 등록 (manifest 머지)
// → 새 session-*.js를 추가하고 manifest만 갱신하면 수동 years/sessions 편집 없이 라이브 반영됨.
//   기존 수동 등록(difficulty/passRate 등)은 보존하고, 누락된 연도/회차만 채운다.
(function mergeSessionsManifest() {
  try {
    Object.entries(sessionsManifest || {}).forEach(([cert, years]) => {
      const exam = examData[cert];
      if (!exam) return; // 메타데이터가 있는 자격증만
      exam.years = exam.years || {};
      Object.entries(years).forEach(([year, sessions]) => {
        const y = exam.years[year] || { difficulty: 'medium', passRate: 25.0 };
        y.sessions = y.sessions || {};
        (sessions || []).forEach((s) => {
          if (!y.sessions[s]) y.sessions[s] = { available: true };
        });
        exam.years[year] = y;
      });
    });
  } catch (e) {
    console.warn('sessionsManifest 머지 실패:', e);
  }
})();

/**
 * 동적 examData를 가져옵니다 (호환성을 위한 함수)
 * @returns {Promise<Object>} examData 객체
 */
export async function getDynamicExamData() {
  return examData;
}

/**
 * 특정 자격증의 사용 가능한 연도 목록을 가져옵니다
 * @param {string} examKey 자격증 키
 * @returns {number[]} 연도 배열
 */
export function getAvailableYears(examKey) {
  const exam = examData[examKey];
  if (exam && exam.years) {
    return Object.keys(exam.years).map(year => parseInt(year)).sort((a, b) => b - a);
  }
  return [];
}

/**
 * 특정 자격증과 연도의 사용 가능한 회차 목록을 가져옵니다
 * @param {string} examKey 자격증 키
 * @param {number} year 연도
 * @returns {number[]} 회차 배열
 */
export function getAvailableSessions(examKey, year) {
  const exam = examData[examKey];
  if (exam && exam.years && exam.years[year] && exam.years[year].sessions) {
    return Object.keys(exam.years[year].sessions).map(session => parseInt(session)).sort();
  }
  return [];
}

/**
 * 사용 가능한 자격증 목록을 가져옵니다
 * @returns {string[]} 자격증 키 배열
 */
export function getAvailableExams() {
  return Object.keys(examData);
}

/**
 * 특정 세션의 시험 데이터를 로딩합니다
 * @param {string} examKey 자격증 키
 * @param {number} year 연도
 * @param {number} session 회차
 * @returns {Promise<Object|null>} 시험 데이터
 */
export async function loadExamSession(examKey, year, session) {
  try {
    // 동적 import로 세션 파일 로딩 시도
    const sessionModule = await import(`./examData/${examKey}/${year}/session-${session}.js`);
    
    if (sessionModule.examSession) {
      return sessionModule.examSession;
    }
    return null;
  } catch (error) {
    // 파일이 없는 경우는 정상적인 상황이므로 조용히 처리
    console.warn(`세션 데이터 로딩 실패: ${examKey}/${year}/session-${session}`);
    return null;
  }
}

// 기본 export
export default examData;